import React from 'react';

import { IconMoreHoriz } from "./icons/Icons";

export default function EllipseButton() {
    return (
        <li>
            <button
                aria-label="Spacer"
                onClick={() => { }} >
                <IconMoreHoriz />
            </button>
        </li>
    );
}
